import { isScheduleNode } from '@sportninja/common/features/competition/operations/utils/nodeTypes'
import type {
  OperationsNode,
  OperationsScheduleNode,
} from '@sportninja/common/features/competition/operations/types/operations.types'

/**
 * Every schedule node that can hold teams — i.e. one that has team children or
 * no children at all. A node whose children are other schedules is a container,
 * not a destination.
 */
export const collectDestinations = (
  nodes: OperationsNode[]
): OperationsScheduleNode[] =>
  nodes.flatMap((node) => {
    if (!isScheduleNode(node)) {
      return []
    }
    const hasChildSchedules = node.children.some(isScheduleNode)
    return hasChildSchedules
      ? collectDestinations(node.children)
      : [node, ...collectDestinations(node.children)]
  })
